/** @format */
import {
    AccessoriesChecklistFlagVariant,
    AccessoriesChecklistVariants,
} from '@toucan/common/features/quote';

import { QuoteFormVariant } from './constants';

export const getQuoteFormVariant = (
    variantName?: AccessoriesChecklistVariants
): QuoteFormVariant => {
    switch (variantName) {
        case AccessoriesChecklistFlagVariant.INLINE_QUOTE_EDITING:
            return QuoteFormVariant.INLINE_QUOTE_EDITING;
        case AccessoriesChecklistFlagVariant.ACCESSORIES_CHECKLIST:
            return QuoteFormVariant.ACCESSORIES_LIST;
        default:
            return QuoteFormVariant.OLD_QUOTE_FORM;
    }
};
